/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { HistoricalReportData, ReportData } from '../../../../types/reportData';
import { getNumberScaleText, getUnitText, getUtrUnitInfo } from '../../../../utils/units';
import { UnitConfig } from '../../../../model/surveyData';
import { UtrVariables } from './constants';

interface UnitInfo {
  unitText: string;
  numberScaleText: string;
}

const getUnitInfo = (
  reportData: ReportData[] | undefined,
  utrCode: string,
  tableColumn: string | undefined,
  unitConfig: { [key: string]: string; } | UnitConfig | undefined
): UnitInfo | undefined => {
  const utrv = reportData?.find(d => d.universalTracker.code === utrCode);
  if (!utrv) {
    return undefined;
  }

  const info = getUtrUnitInfo(utrv.universalTracker, tableColumn, unitConfig as UnitConfig);
  if (!info) {
    return undefined;
  }

  return {
    unitText: getUnitText(info, ''),
    numberScaleText: getNumberScaleText(info.numberScale, ''),
  }
}
/** Find the first one */
export const getUnitForUtrCodes = (historicalReportData: HistoricalReportData[], variables?: UtrVariables) => {
  if (!variables) {
    return;
  }
  for (const variable of Object.values(variables)) {
    for (const { reportData, unitConfig } of historicalReportData) {
      const info = getUnitInfo(reportData, variable.code, variable.valueListCode, unitConfig);
      if (info) {
        return info;
      }
    }
  }
}

export const getUnitWithNumberScale = (unitInfo: UnitInfo | undefined, fallback: string = ''): string | undefined => {
  if (!unitInfo) {
    return fallback;
  }
  const s = [unitInfo.unitText, unitInfo.numberScaleText].filter(Boolean).join(' ');
  return s === '' ? fallback : s;
}
